import { debounce } from 'throttle-debounce';
import { convertSuggestedSpeakers, parseApiSpeakerSuggestions } from 'api/speaker-api-v2';
import { wsV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
import { getSortedNodes, getSpeakerNodesFromDb, getSpeakerNodesFromDocument } from 'screens/DashboardScreen/components/SpeakerModal/speaker-nodes';
export class SpeakerSuggestions {
    constructor(language, diarizationCode, queryDocumentSpeakers, onClose) {
        this.handler = null;
        this.lastQuery = null;
        this.revive = () => {
            try {
                this.websocket.close();
            }
            catch (error) {
                // if closing websocket fails, ignore it
                global.logger.warn('failed to close crashed websocket', {}, error);
            }
            this.websocket = this.connect();
        };
        this.pushQuery = (searchText, scope) => {
            debounce(300, false, () => {
                var _a, _b, _c, _d;
                try {
                    if (searchText.trim() === '') {
                        (_a = this.handler) === null || _a === void 0 ? void 0 : _a.call(this, []);
                        return;
                    }
                    this.lastQuery = { searchText, language: this.language, scope };
                    if (scope === 'document') {
                        const docNodes = this.getDocumentSpeakerNodes(searchText);
                        (_b = this.handler) === null || _b === void 0 ? void 0 : _b.call(this, docNodes);
                        return;
                    }
                    const message = JSON.stringify({ query: searchText, language: (_d = (_c = this.language) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : '' });
                    this.websocket.send(message);
                }
                catch (error) {
                    global.logger.error('failed to send speaker suggestion query', { searchText, language: this.language }, error);
                    this.revive();
                }
            })();
        };
        this.onMessageHandler = (message) => {
            var _a, _b;
            if (this.lastQuery === null) {
                return;
            }
            const data = parseApiSpeakerSuggestions(message.data);
            if (data.Language !== ((_a = this.lastQuery.language) === null || _a === void 0 ? void 0 : _a.code)
                || data.Query !== this.lastQuery.searchText) {
                return;
            }
            const suggestedSpeakers = convertSuggestedSpeakers(data.Suggestions);
            const docNodes = this.getDocumentSpeakerNodes(this.lastQuery.searchText);
            const locale = this.lastQuery.language.code;
            const dbNodes = getSpeakerNodesFromDb(suggestedSpeakers.map((s) => (Object.assign(Object.assign({}, s.speaker), { variantPaths: s.variantPaths }))), locale, true).map((node) => (Object.assign(Object.assign({}, node), { diarizationCode: this.diarizationCode })));
            const allNodes = getSortedNodes(dbNodes, docNodes);
            (_b = this.handler) === null || _b === void 0 ? void 0 : _b.call(this, allNodes);
        };
        this.connect = () => {
            const websocket = new WebSocket(wsV2.speakerSuggestion.url());
            websocket.onmessage = this.onMessageHandler;
            return websocket;
        };
        this.language = language;
        this.queryDocumentSpeakers = queryDocumentSpeakers;
        this.diarizationCode = diarizationCode;
        this.onClose = onClose;
        this.websocket = this.connect();
    }
    onReceivedSuggestions(handler) {
        this.handler = handler;
    }
    offReceivedSuggestions() {
        this.handler = null;
    }
    close() {
        this.websocket.close();
    }
    getDocumentSpeakerNodes(searchText) {
        return getSpeakerNodesFromDocument(this.queryDocumentSpeakers(searchText));
    }
}
